var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M256 2C115.7 2 2 115.7 2 256s113.7 254 254 254 254-113.7 254-254S396.3 2 256 2zm119.6 337.6c9.9 9.9 9.9 26 0 35.9-5 5-21.1 14.9-35.9 0L256 291.9l-83.6 83.6c-5 5-20.2 15.7-35.9 0-9.9-9.9-9.9-26 0-35.9l83.6-83.6-83.6-83.6c-9.9-9.9-9.9-26 0-35.9 9.9-9.9 26-9.9 35.9 0l83.6 83.6 83.6-83.6c9.9-9.9 26-9.9 35.9 0 9.9 9.9 9.9 26 0 35.9L291.9 256l83.7 83.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0fe590f5d558ba9234a17d4159c0c3a4.svg";
export { ForwardRef as ReactComponent };